import { InsuranceService } from './../../shared/services/insurance.service';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { AfterViewInit, Component, HostListener, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, forkJoin } from 'rxjs';
import { LanguageService, UserService, AuthService } from 'src/app/services';
// service
// import { ServiceConfig } from '../../models/Service';
import { ApiService } from 'src/app/services/api.service';
import { BlogService } from 'src/app/services/blog.service';
import { environment } from 'src/environments/environment';
import { SwiperOptions } from 'swiper';
import SwiperCore, { Autoplay, Navigation, Pagination } from 'swiper/core';
import { NavigationOptions, PaginationOptions } from 'swiper/types';
import { CONFIG } from '../../core/config/config';
import { DoctorService } from '../../services/doctor.service';
import { SpecialtyService } from '../../services/specialty.service';
import { translateToEnglish } from '../../shared/helpers/string.utils';
import { ClinicService } from '../../shared/services/clinic.service';
import { LoadingService } from '../../shared/services/loading.service';
import { HelpCrunchService } from '../../shared/services/help-crunch.service';
import { TranslateService } from "@ngx-translate/core";
import { MatDialog } from '@angular/material/dialog';
import { InfoDialogComponent } from 'src/app/shared/dialogs/info-dialog/info-dialog.component';
import { GlobalSuccessPopupComponent } from 'src/app/shared/dialogs/global-success-popup/global-success-popup.component';
import { SuccessService } from 'src/app/shared/services/success.service';
import { GetDraftOrderModel } from 'src/app/models/get-draft-order.model';
import { VideoCallService } from 'src/app/shared/services/video-call.service';

SwiperCore.use([Navigation, Pagination, Autoplay]);


@Component({
  selector: 'app-main-page',
  templateUrl: './main-page.component.html',
  styleUrls: ['./main-page.component.scss']
})
export class MainPageComponent implements OnInit, AfterViewInit {
  env = environment;
  public clinicListSize=0;
  public cLang = CONFIG.LANGS.LANG_DATA.DEFAULT_LANG;
  public newBlogs: any[] = [];
  public url: string = environment.apiUrl;

  /* popular blogs swiper configs */
  public popularBlogNav: NavigationOptions = {
    nextEl: '.blog .new-next',
    prevEl: '.blog .new-prev'
  };
  public popularBlogPagination: PaginationOptions = {
    el: '.blog .pagination'
  };
  public popularBlogConfig: SwiperOptions = {
    direction: 'horizontal',
    slidesPerView: 3,
    keyboard: true,
    mousewheel: false,
    scrollbar: false,
    navigation: this.popularBlogNav,
    pagination: this.popularBlogPagination,
    spaceBetween: 15,
    breakpoints: {
      992: {
        slidesPerView: 3
      },
      576: {
        slidesPerView: 2
      },
      320: {
        slidesPerView: 1
      }
    }
  };

  // /* popular doctors swiper configs */
  public popularDoctorsNav: NavigationOptions = {
    nextEl: '.popular-doctors .new-next',
    prevEl: '.popular-doctors .new-prev'
  };
  public popularDoctorsPagination: PaginationOptions = {
    el: '.popular-doctors .pagination'
  };
  public popularDoctorsConfig: SwiperOptions = {

    direction: 'horizontal',
    slidesPerView: 3,
    keyboard: true,
    mousewheel: false,
    scrollbar: false,
    navigation: this.popularDoctorsNav,
    pagination: this.popularDoctorsPagination,
    spaceBetween: 15,
    breakpoints: {
      992: {
        slidesPerView: 3
      },
      640: {
        slidesPerView: 2
      },
      320: {
        slidesPerView: 1
      }
    },
    autoplay: {
      delay: 3000
    }
  };

  /* popular specialities swiper configs */
  // public popularSpecsNav: NavigationOptions = {
  //   nextEl: '.popular-specs .swiper-button-next',
  //   prevEl: '.popular-specs .swiper-button-prev'
  // };
  // public popularSpecsPagination: PaginationOptions = {
  //   el: '.popular-specs .swiper-pagination'
  // };
  // public popularSpecsConfig: SwiperOptions = {
  //
  //   lazy: true,
  //   direction: 'horizontal',
  //   slidesPerView: 3,
  //   keyboard: true,
  //   mousewheel: false,
  //   scrollbar: false,
  //   navigation: this.popularSpecsNav,
  //   pagination: this.popularSpecsPagination,
  //   spaceBetween: 15,
  //   breakpoints: {
  //     992: {
  //       slidesPerView: 3
  //     },
  //     576: {
  //       slidesPerView: 2
  //     },
  //     320: {
  //       slidesPerView: 1
  //     }
  //   },
  //   autoplay: {
  //     delay: 3000
  //   }
  // };

  public newsNav: NavigationOptions = {
    nextEl: '.news .new-next',
    prevEl: '.news .new-prev'
  };
  public newsPagination: PaginationOptions = {
    el: '.news .pagination'
  };
  public newsConfig: SwiperOptions = {
    lazy: true,
    direction: 'horizontal',
    slidesPerView: 5,
    keyboard: true,
    mousewheel: false,
    scrollbar: false,
    navigation: this.newsNav,
    pagination: this.newsPagination,
    spaceBetween: 0,
    breakpoints: {
      992: {
        slidesPerView: 4,
        spaceBetween: 0,
      },
      576: {
        slidesPerView: 4,
        spaceBetween: 0,
      },
      320: {
        slidesPerView: 2,
        spaceBetween: 0,
      }
    },
    autoplay: {
      delay: 3000
    }
  };

  public popularClinicsNav: NavigationOptions = {
    nextEl: '.popular-clinics .new-next',
    prevEl: '.popular-clinics .new-prev'
  };
  public popularClinicsPagination: PaginationOptions = {
    el: '.popular-clinics .pagination'
  };
  public popularClinicsConfig: SwiperOptions = {
    lazy: true,
    direction: 'horizontal',
    slidesPerView: 2,
    keyboard: true,
    mousewheel: false,
    scrollbar: false,
    navigation: this.popularClinicsNav,
    pagination: this.newsPagination,
    spaceBetween: 15,
    breakpoints: {
      1280: {
        slidesPerView: 4
      },
      992: {
        slidesPerView: 3
      },
      650: {
        slidesPerView: 2
      },
      320: {
        slidesPerView: 1
      }
    },
    autoplay: {
      delay: 3000
    }
  };
  popularClinics: any[] = [];

  blogDataAvailable = false;
  allActiveDoctors: number;
  popularSpecialties: PopularSpecialty[] = [];
  popularDoctors: any[] = [];
  phoneControl = new UntypedFormControl(null, [Validators.minLength(9), Validators.maxLength(9), Validators.pattern('^[0-9]+$')]);
  allDoctors$: Observable<any>;
  public selectedLanguage = localStorage.getItem('CurLang') || 'ka';
  clinicsLength: any;

  isDesktop: boolean = true;
  isMobile: boolean = false;
  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.checkScreenSize();
  }

  constructor(
    private _blogService: BlogService,
    public LS: LanguageService,
    private loadingService: LoadingService,
    public API: ApiService,
    public route: ActivatedRoute,
    @Inject(PLATFORM_ID) private platformId: any,
    private router: Router,
    private meta: Meta,
    private title: Title,
    private specialtyService: SpecialtyService,
    private doctorService: DoctorService,
    private clinicService: ClinicService,
    private userService: UserService,
    private authService: AuthService,
    private successService: SuccessService,
    private insuranceService: InsuranceService,
    public helpCrunchService: HelpCrunchService,
    public dialog: MatDialog,
    @Inject(DOCUMENT) document,
    private translate: TranslateService,
    private videoCallService: VideoCallService
  ) {
    this.getAllNewBlogs();
  }

  ngOnInit() {
    this.videoCallService.getZoomToken(21736).subscribe((token: string) => {
      console.log("token token", token);
    });
    this.checkScreenSize();
    this.checkForDeepLink();
    const redirectUrl = localStorage.getItem('redirectAfterLogin');
    const orderId = localStorage.getItem('redirectAfterLoginOrderId');
    if(redirectUrl && orderId){
      localStorage.removeItem('redirectAfterLogin');
      localStorage.removeItem('redirectAfterLoginOrderId');
      this.API.getDraftOrder({
        OrderId: orderId,
      }).subscribe((response: GetDraftOrderModel) => {
        const orderId = response.orderId;
        const doctorId = response.doctorId;
        const specialtyId = response.specialtyId;
        const serviceTypeId = response.serviceTypeId;
        this.router.navigate([`order-with-insurance`], { 
          queryParams: {
            orderId: orderId,
            doctorId: doctorId,
            ServiceTypeId: serviceTypeId,
            SpecialityId: specialtyId,
            selectedLanguage: this.selectedLanguage
          }
        });
      });
    }
    const popupInfo = this.insuranceService.popupAfterRedirectInfo
    if(popupInfo){
      const infoDialog = this.dialog.open(InfoDialogComponent, {
        width: '420px',
        data: {
          message: popupInfo.message,
          visitTime: popupInfo.visitTime,
          needsAction: popupInfo.needsAction,
          singleButtonAction: popupInfo.singleButtonAction,
          title: popupInfo.title,
          buttonText: popupInfo.buttonText
        }
      });
      infoDialog.afterClosed().subscribe(res => {
        this.insuranceService.popupAfterRedirectInfo = null
        if(res === 'add-insurance-success'){
          this.router.navigate(['/profile/insurance'])
        }
        if(res === 'order-success'){
          this.router.navigate(['/profile/booking'])
        }
      }
      );
    }
    this.clinicService.getClinicsForMainPage()
      .subscribe(
        (clinics => {
          const clinicsList = clinics.data;
          this.clinicListSize=clinicsList.length;
          const sortClinicsList = [];
          let i;
          let j;
          for (i = 0, j = this.clinicListSize; i < j; i += 2) {
            sortClinicsList.push(clinicsList.slice(i, i + 2));
          }
          this.popularClinics = sortClinicsList;
          // this.clinics = clinics.data;

          this.clinicsLength = clinics.data.length
        })
      );

    // if (isPlatformBrowser(this.platformId)) {
    //   const iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
    //   const android = !!navigator.platform && /android/i.test(navigator.platform);
    //   if (iOS) {
    //     window.location.href = 'https://apps.apple.com/sr/app/redmed/id1483844703'
    //   } else if (android) {
    //     window.location.replace('intent://redmed.ge/#Intent;scheme=https;package=ge.redmed.patient;end');
    //   }
    // }
    this.userService.getUser
      .subscribe(
        (user) => {
          if (user && user.isDoctor) {
            this.router.navigate([`profile/booking`])
              .then();
          } else {
            this.initMainPageData();
          }
        });

    this.checkForDeepLink();
    this.getAllDoctors();
    this.doctorService.getAllActivateDoctors().subscribe(resp => this.allActiveDoctors = resp.data)
  }

  ngAfterViewInit(): void {
    if(localStorage.getItem('needReload') === 'true'){
      localStorage.removeItem('needReload');
      window.location.reload();
    }
    this.translate.get('i-use-redmed').subscribe(event => {
      const ref = this.route.snapshot.queryParamMap.get('ref');
      if (ref && ref === 'order') {
        this.meta.updateTag({property: 'og:title', content: this.translate.instant('i-use-redmed')});
        this.meta.updateTag({
          property: 'og:description',
          content: `${this.translate.instant('call-a-doctor-at-home-or-receive-remote-medical-services')}.`
        });
        this.meta.updateTag({ property: 'og:url', content: `https://redmed.ge?ref=order` });
      } else {
        this.meta.updateTag({property: 'og:title', content: 'REDMED - ' + this.translate.instant('doctor-with-you')});
        this.meta.updateTag({
          property: 'og:description',
          content: `REDMED ${this.translate.instant('first-innovative-medical-platform-in-georgia')}.`
        });
        this.meta.updateTag({property: 'og:url', content: `https://redmed.ge`});
      }
      this.meta.updateTag({property: 'og:type', content: 'website'});
      this.meta.updateTag({property: 'og:image', content: `https://redmed.ge/assets/img/Red.png`});
      this.meta.updateTag({
        property: 'description',
        content: `REDMED - ${this.selectedLanguage} ${this.translate.instant('first-innovative-medical-platform-in-georgia')}.`
      });
      this.meta.updateTag({
        name: 'description',
        content: `REDMED ${this.translate.instant('first-innovative-medical-platform-in-georgia')}.`
      });
      this.title.setTitle(this.translate.instant('doctor-online-consultation') + ' | REDMED - ' + this.translate.instant('doctor-with-you'));
    });
  }

  initMainPageData() {
    /*
    * 1. პოპულარული სპეციალობები
    * 2. პოპულარული ექიმები
    * 3. კლინიკები
    */
    forkJoin([
      this.specialtyService.getPopularSpecialties(),
      this.doctorService.getPopularDoctors()
      // this.clinicService.getClinics()
    ]).subscribe((resultSet: any[]) => {
      this.popularSpecialties = resultSet[0];
      this.popularDoctors = resultSet[1].result;
      // this.clinics = resultSet[2].data;
    });
  }

  goToSelectedSpecialty(specialty: any) {
    this.router.navigate([`/specialoba/${specialty.specialityNameLat}`]);
  }

  goToNewBlog(id: number, title: string) {
    this.router.navigate([`/blog-new/${translateToEnglish(title.replace(/ - /g, '-').replace(/ /g, '-'))}/${id}`]);
  }

  updateUrl($event) {
    $event.target.src = 'assets/photos/avatar-3.png';
  }

  sendDownloadLink() {
    if (this.phoneControl.valid) {
      const data = {
        phone: '995' + this.phoneControl.value
      };
      this.loadingService.setApplicationLoading(true);
      this.API.sendDownloadUrl(data)
        .subscribe(
          (response: any) => {
            this.loadingService.setApplicationLoading(false);
          }, () => {
            this.loadingService.setApplicationLoading(false);
          }
        );
    }
  }

  translateToEnglish(s: string) {
    return translateToEnglish(s);
  }

  goToClinic(clinic: any) {
    this.router.navigate(['/search'], {
      queryParams: {
        clinic: clinic.id
      }
    });
  }

  goToPharma() {
    if (isPlatformBrowser(this.platformId)) {
      if (localStorage.getItem('UserAccessToken')) {
        window.open(`https://${environment.production ? 'pharma' : 'pharmastage'}.redmed.ge?token=${this.fixedEncodeURIComponent(localStorage.getItem('UserAccessToken'))}&selectedLanguage=${this.selectedLanguage}`);
        // window.open(`https://pharma${environment.production ? '' : 'stage'}.redmed.ge?token=${this.fixedEncodeURIComponent(localStorage.getItem('UserAccessToken'))}`); old version
        return;
      }
    }
    window.open(`https://${environment.production ? 'pharma' : 'pharmastage'}.redmed.ge?selectedLanguage=${this.selectedLanguage}`);
    // window.open(`https://pharma${environment.production ? '' : 'stage'}.redmed.ge`); old version
  }

  fixedEncodeURIComponent(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
      return '%' + c.charCodeAt(0).toString(16);
    });
  }

  goToClinicWeb(lab?: string) {
    if (isPlatformBrowser(this.platformId)) {
      if (lab) {
        let url = `https://clinic${environment.production ? '' : 'stage'}.redmed.ge/auth?token=${this.fixedEncodeURIComponent(localStorage.getItem('UserAccessToken'))}&page=&step=search&selector=lab&selectedLanguage=${this.selectedLanguage}`;
        if (lab === 'lab-home') {
          url += '&test-type-id=1';
        }
        window.open(url);
        return;
      }
      if (localStorage.getItem('UserAccessToken')) {
        window.open(`https://clinic${environment.production ? '' : 'stage'}.redmed.ge/auth?token=${this.fixedEncodeURIComponent(localStorage.getItem('UserAccessToken'))}&selectedLanguage=${this.selectedLanguage}`);
        return;
      }
    }
    window.open(`https://clinic${environment.production ? '' : 'stage'}.redmed.ge?selectedLanguage=${this.selectedLanguage}`);
  }

  getAllDoctors() {
    this.allDoctors$ = this.doctorService.getAllDoctors();
  }
  goToNurseAtHome(){
    window.open(`https://clinic${environment.production ? '' : 'stage'}.redmed.ge/auth?token=${this.fixedEncodeURIComponent(localStorage.getItem('UserAccessToken'))}&page=&step=search&selector=nurse&selectedLanguage=${this.selectedLanguage}`);

  }

  goToCompany(clinicId?: number) {
    if (isPlatformBrowser(this.platformId)) {
      let url = '';
      if (clinicId) {
        url = `https://clinic${environment.production ? '' : 'stage'}.redmed.ge/auth?token=${this.fixedEncodeURIComponent(localStorage.getItem('UserAccessToken'))}&page=clinic-branches/${clinicId}`;
      }
      else {
        url = `https://clinic${environment.production ? '' : 'stage'}.redmed.ge/auth?token=${this.fixedEncodeURIComponent(localStorage.getItem('UserAccessToken'))}&page=&step=search&selector=companies`;
      }
      window.open(url + `&selectedLanguage=${this.selectedLanguage}`);
      return;
    }
    window.open(`https://clinic${environment.production ? '' : 'stage'}.redmed.ge?selectedLanguage=${this.selectedLanguage}`);
  }

  onInsuranceProviderDoctorBubbleClick(): void {
    this.insuranceService.insuranceProviderDoctorBubbleLogic(this.selectedLanguage);
  }

  /* new blogs */
  private getAllNewBlogs(): void {
    this._blogService.getAllBlog(5).subscribe(
      result => {
        this.newBlogs = result.content;
        this.blogDataAvailable = true;
      },
      error => {
        console.log(error.error);
      });
  }

  checkScreenSize(): void {
    this.isDesktop = window.innerWidth > 768; // Adjust the threshold according to your design breakpoints
    this.isMobile = window.innerWidth < 576;
  }

  private checkForDeepLink(): void {
    if (isPlatformBrowser(this.platformId)) {
      const isInsuranceDeepLink = window.location.href.indexOf('insurance-deep-link') !== -1;
      if (isInsuranceDeepLink) {
        this.onInsuranceProviderDoctorBubbleClick();
      }
      const isBookingDeepLink = window.location.href.indexOf('booking-deep-link') !== -1;
      if (isBookingDeepLink) {
        const urlParams = new URLSearchParams(window.location.search);
        const orderId = urlParams.get('orderId');
        // Check if user is logged in
        if (this.authService.isLogged()) {
          this.API.getDraftOrder({
            OrderId: orderId,
          }).subscribe((response: GetDraftOrderModel) => {
            console.log(response, "response 22");
            const orderId = response.orderId;
            const doctorId = response.doctorId;
            const specialtyId = response.specialtyId;
            const serviceTypeId = response.serviceTypeId;
            this.router.navigate([`order-with-insurance`], { 
              queryParams: {
                orderId: orderId,
                doctorId: doctorId,
                ServiceTypeId: serviceTypeId,
                SpecialityId: specialtyId,
                selectedLanguage: this.selectedLanguage
              }
            });
          });
        } else {
          // Store the intended destination
          localStorage.setItem('redirectAfterLogin', '/profile/booking');
          localStorage.setItem('redirectAfterLoginOrderId', orderId);
          // Redirect to login page
          this.router.navigate(['/user/auth-user']);
        }
      }
    }
  }
}

export interface PopularSpecialty {
  sortingNumber: number;
  specialityId: number;
  specialityName: string;
  specialityShortDesc: string;
}
